import { INITIAL_SOLUTIONS_LENGTH } from '../contstants';
export const trimEstimationSolutions = (solutions, enableTrim = false) => {
    if (!enableTrim) {
        return solutions;
    }
    return solutions.slice(0, INITIAL_SOLUTIONS_LENGTH);
};
